import {useErrorHandler} from 'app/utils'
import {reactQueryBasicConfig} from 'app/utils'
import {AxiosError} from 'axios'
import {useQuery} from 'react-query'
import {getMeReq} from './apis'

export const useUser = (token: any) => {
  const errorHandler = useErrorHandler()
  return useQuery(['currentUser'], () => getMeReq(), {
    ...reactQueryBasicConfig(),
    enabled: !!token,
    onError: (err) => errorHandler(err as AxiosError),
  })
}
